/**
 * Ayuda y soporte (17-sep-2026, Rais: «falta poner el enlace a una página, aunque sea provisional;
 * describir el soporte; que salga un formulario»).
 *
 * El formulario NO manda nada por su cuenta: abre el programa de correo del autor con el mensaje ya
 * escrito. Así no hace falta un servidor nuevo antes del curso, el autor ve exactamente qué envía y
 * la respuesta le llega a su correo. Lo que se añade solo —versión del motor y sistema— se ve en el
 * propio mensaje antes de enviarlo, y se puede quitar.
 */
import { useState } from "react";

const GUIA = "https://humanink.io/docs/es/como-se-usa";
const SOPORTE = "soporte@humanink.io";

const TEMAS = [
  "Algo no funciona",
  "No sé cómo hacer algo",
  "Mi cuenta o mi suscripción",
  "Instalar o actualizar el motor",
  "Una sugerencia",
];

export default function Ayuda({ version }: { version?: string | null }) {
  const [tema, setTema] = useState(TEMAS[0]);
  const [texto, setTexto] = useState("");
  const [datos, setDatos] = useState(true);

  const sistema = /Windows/i.test(navigator.userAgent) ? "Windows" : /Mac/i.test(navigator.userAgent) ? "Mac" : "otro";
  const cuerpo = texto.trim() + (datos ? `\n\n—\nMotor: ${version ?? "sin motor"} · Sistema: ${sistema}` : "");
  const enlace = `mailto:${SOPORTE}?subject=${encodeURIComponent(`[Studio] ${tema}`)}&body=${encodeURIComponent(cuerpo)}`;

  return (
    <>
      <section className="carta">
        <h2>La guía<span className="sub">provisional</span></h2>
        <p className="vacio">
          Cómo se instala el motor, cómo se trae un libro y qué hace cada agente, paso a paso. Se va
          ampliando con lo que nos preguntáis.
        </p>
        <div className="botones">
          <a className="btn fantasma" href={GUIA} target="_blank" rel="noopener">Abrir la guía</a>
        </div>
      </section>

      <section className="carta">
        <h2>Cómo funciona el soporte</h2>
        <dl className="ficha-actual">
          <div><dt>Quién</dt><dd>Te contesta una persona del equipo de HumanInk, no un bot.</dd></div>
          <div><dt>Dónde</dt><dd>Por correo, en <b>{SOPORTE}</b>, a la dirección desde la que escribas.</dd></div>
          <div><dt>Qué contar</dt><dd>Qué estabas haciendo, qué esperabas y qué ha pasado. Una captura ayuda mucho.</dd></div>
          <div><dt>Tu libro</dt><dd>No nos mandes el manuscrito: casi nunca hace falta, y si hiciera falta te lo pediríamos.</dd></div>
        </dl>
      </section>

      <section className="carta">
        <h2>Escríbenos<span className="sub">se abre tu correo con el mensaje escrito</span></h2>
        <div className="formulario">
          <label className="campo">
            <span>De qué se trata</span>
            <select className="escribir" value={tema} onChange={(e) => setTema(e.target.value)}>
              {TEMAS.map((t) => <option key={t}>{t}</option>)}
            </select>
          </label>
          <label className="campo">
            <span>Cuéntanos</span>
            <div className="dir">
              <textarea className="escribir" rows={6} style={{ resize: "vertical" }}
                        placeholder="Qué estabas haciendo, qué esperabas y qué ha pasado."
                        value={texto} onChange={(e) => setTexto(e.target.value)} />
            </div>
          </label>
          <label className="vacio" style={{ display: "flex", gap: 8, alignItems: "center", cursor: "pointer" }}>
            <input type="checkbox" checked={datos} onChange={(e) => setDatos(e.target.checked)} />
            Añadir la versión del motor ({version ?? "sin motor"}) y el sistema ({sistema}). Nada más.
          </label>
          <div className="pie-form">
            <p className="vacio">Lo envías tú desde tu correo; aquí no se guarda nada.</p>
            {texto.trim()
              ? <a className="btn" href={enlace}>Preparar el correo</a>
              : <button className="btn" disabled>Preparar el correo</button>}
          </div>
        </div>
      </section>
    </>
  );
}
